import loggedIn from "./i18n/loggedIn"
import cleanRoute from "./i18n/cleanRoute"
import slashAdder from "./i18n/slashAdder"
import pathCleaner from "./i18n/pathCleaner"
import doubleSlashRemover from "./i18n/doubleSlashRemover"

export default function (context) {
  const { app, store, route, params, redirect } = context
  const urlParamLoc = params.lang
  const availableLangs = store.state.locales
  const locale =
    store.getters["user/IS_LOGGED_IN"] &&
    !route.fullPath.includes("band/signup")
      ? loggedIn(context)
      : app.i18n.locale
  let fullPath = slashAdder(route.path.toString())
  let shortPath = pathCleaner(fullPath, urlParamLoc)

  if (doubleSlashRemover(fullPath) !== fullPath)
    return redirect(doubleSlashRemover(fullPath))

  if (cleanRoute(context, shortPath)) {
    if (urlParamLoc !== locale) {
      if (!urlParamLoc) return proxy_redirection(locale, shortPath, context)
      else {
        if (availableLangs.includes(urlParamLoc)) {
          if (
            store.getters["user/IS_LOGGED_IN"] &&
            !route.fullPath.includes("band/signup")
          )
            return proxy_redirection(locale, shortPath, context)
        } else if (shortPath !== "/") {
          return proxy_redirection(locale, shortPath, context)
        } else return proxy_redirection(locale, "/", context)
      }
    }
    if (fullPath !== route.path) return redirect(fullPath, route.query)
  }
  setLang(urlParamLoc, context)
}

function proxy_redirection(lang, url, { redirect, app, store, route }) {
  setLang(lang, { app, store })
  return redirect(302, `/${lang}${url}`, route.query)
}

function setLang(lang, { app, store }) {
  app.i18n.locale = lang
  app.$cookies.set("lang", lang)
  store.commit("SET_LANG", lang)
}
